import { memo } from 'react';
import { MessageStatus } from '@connect-x-app/shared-domain-models';
import { IconName } from '@connect-x-app/shared-types';

import { Icon } from '../icon';

type Props = {
  size?: number;
  status: MessageStatus | null;
};

const statusToIcon = (status: MessageStatus): IconName | undefined => {
  switch (status) {
    case MessageStatus.SENT:
      return 'singleCheckmark';
    case MessageStatus.DELIVERED:
      return 'doubleCheckmark';
    case MessageStatus.READ:
      return 'doubleCheckmarkBgCircle';
    default:
      return undefined;
  }
};

export const MessageStatusIcon = memo(({ size = 1.5, status }: Props) => {
  if (!status) {
    return null;
  }

  const iconName = statusToIcon(status);
  return iconName ? <Icon name={iconName} size={size} /> : null;
});
